export default __webpack_public_path__ + "9fae8d6de86f3c9321cdc381cf45f1ce.png";